module.exports = __webpack_public_path__ + "static/media/no-friends-requests.5385ec49.lottie";